export class ReportSearch {
  constructor(
    public startDate?: string,
    public endDate?: string,
    public pageNumber?: number,
    public pageSize?: number,
    public ngbid?: number,
    public requestId?: string,
    public portalId?: number
  ) {}
}
